import React from "react";
import Modal from "../../components/modal/index";
import {FlexContainer, Text} from "../../design";

type Props = {
  isOpen: boolean,
  header: string,
  body: string,
  title: String,
}

const SoldOutModal = (props : Props) => {
  return (
    <Modal isOpen={props.isOpen}>
        <FlexContainer
            height="400px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            box-shadow="0 0 20px 0 rgba(0, 0, 0, 0.1)"
            backdropFilter='none'
            borderRadius='4px'
            backgroundColor="#f2f5f8"
            textAlign='center'
            alignContent='none'
            paddingTop="10px"
            paddingLeft="10px"
            paddingRight="10px"
            paddingBottom="10px"
        >
            <Text
                fontSize="20px"
                fontWeight='600'
            >
                {props.title}
            </Text>
            <Text
                fontSize="20px"
                fontWeight='600'
                textAlign='center'
            >
                {props.header}
            </Text>
            <Text
                fontSize="16px"
                textAlign='center'
            >
                {props.body}
            </Text>
        </FlexContainer>
    </Modal>
  )
};

export default SoldOutModal;
